const fromNow = (duration) => {
  // Duration is positive
  const d = Math.abs(duration);

  if (d === 0) {
    return "Today";
  }

  if (Math.sign(duration) === 1 || Math.sign(duration) === 0) {
    return `in ${d} ${d === 1 ? "day" : "days"}`;
    // Duration is negative
  }
  return `${d} ${d === 1 ? "day" : "days"} ago`;
};

export default fromNow;
